import Button, { ButtonProps } from './Button'
import { BUTTON_SIZE, BUTTON_TYPES } from './button.constants'

export default Button

export { Button, BUTTON_SIZE, BUTTON_TYPES }
export type { ButtonProps }
